import { render, staticRenderFns } from "./HonoringInclusion.vue?vue&type=template&id=0ff4ab35&"
import script from "./HonoringInclusion.vue?vue&type=script&lang=ts&"
export * from "./HonoringInclusion.vue?vue&type=script&lang=ts&"
import style0 from "./HonoringInclusion.vue?vue&type=style&index=0&id=0ff4ab35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports